import { SearchApi } from '@ps/api/search';
import {
  OrderEnumItem,
  SearchCommunityChannelMessageSortByEnumItem,
} from '@ps/api/types';
import { withClientAPI } from '@ps/functions/utils/api';

import type { ExtendedCommunityChannelMessage } from '../../types/ExtendedCommunityChannelMessage';
import { channelMessageSearchItemToMessage } from './channelMessageSearchItemToMessage';

const kDefaultPageSize = 30;

/**
 * Initial page of top-level (`level === 1`) messages for a channel,
 * newest-first. Pagination + live append are layered on by the
 * caller; this is a flat one-page fetch, mirroring how PopshopRN
 * seeds its message provider before attaching the Firestore listener.
 */
export async function fetchChannelMessages(
  creatorId: string,
  channelId: string,
  {
    pageSize = kDefaultPageSize,
    cursor,
  }: { pageSize?: number; cursor?: string } = {},
): Promise<{
  messages: ExtendedCommunityChannelMessage[];
  cursor: string | undefined;
}> {
  const api = withClientAPI(SearchApi);
  const res = await api.searchApiControllerSearchStoreCommunityChannelMessages({
    storeId: creatorId,
    channelId,
    pageNo: 1,
    pageSize,
    level: 1,
    sortBy: SearchCommunityChannelMessageSortByEnumItem.CreatedAt,
    order: OrderEnumItem.Desc,
    cursor,
  });
  return {
    messages: res.data.rows.map(row =>
      channelMessageSearchItemToMessage(channelId, row),
    ),
    cursor: res.cursor,
  };
}
